module.exports = __webpack_public_path__ + "img/kachel-04.0c049d71.jpg";